<template>
  <div class="layout-wrapper home-layout-wrapper position-relative">
    <comp-navbar></comp-navbar>
    <main class="main">
      <router-view v-slot="{ Component }">
        <transition name="fade-transform" mode="out-in">
          <div :key="$route.name || $route.path">
            <keep-alive :exclude="/Exclude/">
              <component :is="Component" />
            </keep-alive>
          </div>
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script lang="ts">
export default {
  name: 'LayoutHome'
}
</script>

<script lang="ts" setup>
import { provide, ref } from 'vue'

const activeIndex = ref('home')

const updateActiveIndex = (index: string) => {
  activeIndex.value = index || ''
}

const pathnameSplits = window.location.pathname.split('/')
if (pathnameSplits.length >= 2) {
  const activeIndexValue = pathnameSplits[1]
  if (activeIndexValue) updateActiveIndex(activeIndexValue)
}

provide('menuProps', {
  activeIndex,
  updateActiveIndex
})
</script>

<style lang="scss" scoped>
.layout-wrapper {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  .main {
    // display: flex;
    width: 100%;
    height: 100vh;
  }
}
</style>
